import React, { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import {
  isEndedEvent,
  isValidForeignersCode,
  isValidIranianNationalCode,
  numToEn,
  registerPrintUrl,
  siteBaseUrl,
  jalaliDateToGregorianApi,
  toJalaliPickerValue,
} from '../../Shared/utils/helper';
import Master from '../Layouts/Master';
import {
  DatePic,
  File,
  Image,
  List,
  Number as NumberField,
  Text,
  Textarea,
} from './Elements';
import Checkbox from './Elements/Checkbox';
import EventType from './EventType';
import Team from './Team';
import validations from './Validation/Validation';

const EditRegister = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const eventContext = useContext(EventContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [natCode, setNatCode] = useState('');
  const [natSupervisorCode, setNatSupervisorCode] = useState('');
  const [mobile, setMobile] = useState('');
  const [foreigners, setForeigners] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loadSearchForm, setLoadSearchForm] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRoleIsOpen, setModalRoleIsOpen] = useState(false);
  const [modalAddTeam, setModalAddTeam] = useState(false);
  const [issueTracking, setIssueTracking] = useState('');
  const [createDate, setCreateDate] = useState('');
  // const [natCodeEventType, setNatCodeEventType] = useState('');
  const [clubName, setClubName] = useState('');
  const [provinceId, setProvinceId] = useState('');
  const [city, setCity] = useState('');
  const [clubPhone, setClubPhone] = useState('');
  const [showTeamForm, setShowTeamForm] = useState(false);
  const [showUserRegisterForm, setShowUserRegisterForm] = useState(false);
  const [loadSwitch, setLoadSwitch] = useState(false);
  const [userId, setUserId] = useState('');
  const [teamId, setTeamId] = useState('');
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [retryPayMessage, setRetryPayMessage] = useState('');
  const [removeLoading, setRemoveLoading] = useState(false);
  const [modalIssueTracking, setModalIssueTracking] = useState(false);
  const [fandomField, setFandomField] = useState({
    province_id: '',
    organizer_id: null,
    city_id: '',
    team_id: '',
    club_phone: '',
  });

  useEffect(() => {
    if (
      state?.teamId == undefined ||
      state?.teamId == null ||
      id == undefined ||
      id == null
    ) {
      navigate('/');
      return;
    }
  }, [state, id]);

  useEffect(() => {
    getData();
  }, [state, id]);

  const getData = async () => {
    setLoading(true);
    await useApi.get(
      `/team/event/${id}/my-team/${state?.teamId}`,
      {},
      (res) => {
        const { event, team } = res.data.data;
        if (isEndedEvent(event)) {
          return navigate('/', { replace: true });
        }
        eventContext.team = team;
        eventContext.event = event;
        eventContext.users = team?.users || [];
        if (
          eventContext.event?.fandom_type == 1 &&
          eventContext.team?.fandom != undefined &&
          eventContext.team?.fandom != null
        ) {
          onChangeValue('fandom', `${eventContext.team?.fandom?.id}`, true);
          onChangeValue(
            'province_id',
            `${eventContext.team?.province_id}`,
            true,
          );
          getCities(eventContext.team?.province_id);
          onChangeValue('city_id', `${eventContext.team?.city_id}`, true);
          onChangeValue('region', `${eventContext.team?.region}`, true);
          onChangeValue('club_phone', `${eventContext.team?.club_phone}`, true);
        } else {
          onChangeValue('city', eventContext.team?.city, true);
          onChangeValue('club_name', eventContext.team?.club_name, true);
          onChangeValue('club_phone', eventContext.team?.club_phone, true);
          onChangeValue(
            'province_id',
            `${eventContext.team?.province_id}`,
            true,
          );
        }
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
    setLoading(false);
  };

  const getProvince = async () => {
    await useApi.get(
      '/province',
      {},
      (res) => {
        eventContext.provinces = res.data.data;
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const getFandoms = async () => {
    useApi.get(
      '/fandom?no-paginate=true',
      {},
      (res) => {
        eventContext.fandoms = res.data.data;
      },
      (err) => {
        error('خطا در دریافت اطلاعات');
        setLoading(false);
      },
    );
  };

  const formGenerate = (field, teamForm = false) => {
    let fieldType = field.type;

    switch (fieldType) {
      case 'text':
        return (
          <Text
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
          />
        );
      case 'date':
        return (
          <DatePic
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
          />
        );
      case 'list':
        return (
          <List
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
            eventContext={eventContext}
            getCities={eventContext.event?.fandom_type == 1 ? getCities : null}
            cityLoading={cityLoading}
          />
        );
      case 'number':
        return (
          <NumberField
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
          />
        );
      case 'img':
        return (
          <Image
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
            setErrors={setErrors}
          />
        );
      case 'file':
        return (
          <File
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
            setErrors={setErrors}
          />
        );
      case 'textarea':
        return (
          <Textarea
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
          />
        );
      case 'checkbox':
        return (
          <Checkbox
            field={field}
            teamForm={teamForm}
            onChangeValue={onChangeValue}
          />
        );
      default:
        break;
    }
  };

  const getFormDataValue = (formTeam = false) => {
    let fields = formTeam
      ? eventContext.event?.team_form?.fields
      : eventContext.event?.form?.fields;
    let formData = {};
    fields.forEach((field) => {
      if (field.type === 'date') {
        formData[field.name] = jalaliDateToGregorianApi(field.value);
        return;
      }

      formData[field.name] = field.value;
    });

    if (formData.nat_code === undefined || formData.nat_code === '') {
      if (natCode) {
        const rawNat = numToEn(String(natCode).replace(/^FGN-/i, ''));
        formData.nat_code = foreigners ? `FGN-${rawNat}` : rawNat;
      } else {
        formData.nat_code = null;
      }
    }
    if (formData.mobile === undefined || formData.mobile === '') {
      formData.mobile = mobile ? numToEn(mobile) : formData.mobile ?? null;
    }

    return formData;
  };

  const onChangeValue = (fieldName, value, teamForm = false) => {
    const fields = teamForm
      ? [...eventContext.event.team_form.fields]
      : [...eventContext.event.form.fields];
    let findIndexField = fields.findIndex((f) => f.name === fieldName);

    if (findIndexField !== -1) {
      if (
        fields[findIndexField].type != 'img' &&
        fields[findIndexField].type != 'checkbox'
      ) {
        fields[findIndexField].value = numToEn(value);
      } else {
        fields[findIndexField].value = value;
      }
      if (fieldName === 'nat_code' && !teamForm) {
        setNatCode(fields[findIndexField].value);
      }
      if (fieldName === 'mobile' && !teamForm) {
        setMobile(fields[findIndexField].value);
      }
    }
    if (teamForm) {
      eventContext.event.team_form.fields = fields;
    }
    if (!teamForm) {
      eventContext.event.form.fields = fields;
    }
  };

  const registerInEvent = async (e, createUserOnly = false) => {
    e.preventDefault();
    let validated = validations.validate(
      eventContext.event.form.fields,
      errors,
      setErrors,
      eventContext.event,
    );

    if (!validated) {
      return;
    }

    setSubmitFormLoading(true);
    let requestData = getFormDataValue();
    // data['nat_code'] = numToEn(natCode);
    // data['mobile'] = numToEn(mobile);
    if (!createUserOnly) {
      requestData['event_id'] = id;
    }
    //Alow register repeat user
    if (
      createUserOnly &&
      requestData.field_id != undefined &&
      requestData.field_id != null &&
      (requestData.field_id == 8 || 2 || 3)
    ) {
      requestData['repeat_nat_code'] = 'true';
    }
    //Alow register repeat user
    await useApi.post(
      '/user',
      requestData,
      (res) => {
        let data = res.data.data;

        let event = data?.events?.find((e) => e.id == id);
        if (!createUserOnly) {
          if (data?.issue_tracking != undefined && data?.success == false) {
            setModalRoleIsOpen(false);
            setSubmitFormLoading(false);
            setOpenErrorModal(true);
            setRetryPayMessage(
              'شما هزینه رویداد را پرداخت نکرده اید لطفا به منوی پرداخت از طریق کد پیگیری مراجعه نموده و از طریق کد پیگیری زیر نسبت به پرداخت حق عضویت خود اقدام نمایید. ',
            );
            setIssueTracking(data?.issue_tracking);
            return error('لطفا حق عضویت خود را پرداخت نمایید');
          }
          if (eventContext.event.free === 0) {
            return redirectToPaymentGateway(
              true,
              null,
              data?.event?.issue_tracking,
            );
          }
        }
        success('اطلاعات شما با موفقیت ثبت شد');
        setUserId(
          encodeURIComponent(data?.event?.issue_tracking?.replaceAll('/', '_')),
        );
        if (!createUserOnly) {
          setIssueTracking(data?.event?.issue_tracking);
          setModalRoleIsOpen(false);
          setModalIsOpen(true);
        }
        if (createUserOnly) {
          let users = [...eventContext.users];
          let findIndexUser = users.findIndex(
            (u) => u.nat_code === requestData?.nat_code,
          );
          // requestData['id'] = data['id'];
          if (findIndexUser !== -1) {
            users[findIndexUser] = requestData;
          } else {
            users.push(requestData);
          }
          eventContext.users = users;
          resetUserForm(requestData);
          setSearchLoading(false);
          setShowUserRegisterForm(false);
        }
        setSubmitFormLoading(false);
        // return navigate('/', { replace: true });
      },
      (err) => {
        if (err?.status === 422) {
          if (err?.data?.error !== undefined) {
            setModalIssueTracking(true);
            setIssueTracking(err?.data?.issue_tracking);
            error(`شما قبلا در ${eventContext.event.title} ثبت نام کرده اید`);
          }
          if (err?.data?.errors?.nat_code != undefined) {
            error(err?.data?.errors?.nat_code[0]);
          }
          if (err?.data?.errors?.mobile != undefined) {
            error(err?.data?.errors?.mobile[0]);
          }
        } else {
          error('اطلاعات به علت خطا ثبت نشد');
        }

        setSubmitFormLoading(false);
      },
    );
  };

  const resetUserForm = (requestData) => {
    setNatCode('');
    setMobile('');
    eventContext.user = {};
    Object.entries(requestData).forEach((item) => {
      onChangeValue(item[0], '');
    });
  };

  const redirectToPaymentGateway = async (
    userRegister = null,
    teamRegister,
    issueTracking,
  ) => {
    let data = {};
    if (userRegister !== null && userRegister) {
      data['user'] = userRegister;
    }
    if (teamRegister !== null && teamRegister) {
      data['team'] = teamRegister;
    }
    data['event_id'] = eventContext.event.id;
    await useApi.post(
      '/payment',
      data,
      (res) => {
        data = res.data.data;
        if (data['success'] == false) {
          setModalRoleIsOpen(false);
          setSubmitFormLoading(false);
          setOpenErrorModal(true);
          setIssueTracking(issueTracking);
          return error(data['message'] ?? '');
        }
        setSubmitFormLoading(false);
        return (window.location.href = data.redirect_url);
      },
      (err) => {
        setModalRoleIsOpen(false);
        setSubmitFormLoading(false);
        setOpenErrorModal(true);
        setIssueTracking(issueTracking);
        error('خطای ناشناخته هنگام اتصال به درگاه پرداخت');
      },
    );
  };

  const searchUser = async () => {
    if (!foreigners && !isValidIranianNationalCode(natCode)) {
      setSearchLoading(false);
      return error('کد ملی اشتباه است');
    }
    if (foreigners && !isValidForeignersCode(natCode)) {
      setSearchLoading(false);
      return error('کد اتباع اشتباه است');
    }
    if (mobile.length < 11 || mobile.length > 11 || mobile[0] != 0) {
      setSearchLoading(false);
      return error('شماره همراه باید 11 رقم باشید و با 0 شروع شود');
    }
    setSearchLoading(false);
    setLoadSearchForm(true);

    await useApi.get(
      `/user/search/${natCode}/${mobile}?event_id=${eventContext.event?.id}`,
      {},
      (res) => {
        let fields = [...eventContext.event.form.fields];
        const { data } = res.data;
        if (data.length > 0) {
          Object.entries(data[0]).forEach((user, index) => {
            let findFieldIndex = fields.findIndex((f) => f.name === user[0]);

            if (findFieldIndex !== -1) {
              if (fields[findFieldIndex].type === 'date') {
                fields[findFieldIndex].value =
                  user[1] == null ? null : toJalaliPickerValue(user[1]);
              } else if (fields[findFieldIndex].name === 'nat_code') {
                const rawCode = user[1];
                if (rawCode && String(rawCode).substr(0, 4) === 'FGN-') {
                  fields[findFieldIndex]['isForeigners'] = true;
                  fields[findFieldIndex].value = String(rawCode).substr(4);
                } else {
                  fields[findFieldIndex].value = rawCode || numToEn(natCode);
                }
              } else {
                fields[findFieldIndex].value = user[1];
              }
            }
          });

          eventContext.event.form.fields = fields;
        } else {
          fields.forEach((item) => {
            let findFieldIndex = fields.findIndex((f) => f.name === item.name);
            fields[findFieldIndex].value = null;
          });
        }

        setSearchLoading(true);
        setLoadSearchForm(false);
      },
      (err) => {
        setLoadSearchForm(false);
        error('هنگام جستجو مشکلی پیش آمده است');
      },
    );
  };

  const searchTeam = async () => {
    eventContext.users = [];
    if (clubName.length === 0) {
      setShowTeamForm(false);
      return error('نام باشگاه الزامی است');
    }
    if (clubPhone.length === 0) {
      setShowTeamForm(false);
      return error('انتخاب استان الزامی است');
    }
    let regex = /^0[0-9][0-9][0-9]{8}$/;

    if (!regex.test(clubPhone)) {
      setShowTeamForm(false);
      return error('لطفا تلفن باشگاه را  صحیح و به همراه کد شهر وارد کنید');
    }

    setShowTeamForm(false);
    setLoadSearchForm(true);
    await useApi.get(
      `/team/search/${clubName}/${clubPhone}`,
      {},
      (res) => {
        let data = res.data.data;
        eventContext.teams = data;

        if (data.length === 0) {
          nullValueTeamField();
          setShowTeamForm(true);
        } else {
          setModalAddTeam(true);
        }

        setLoadSearchForm(false);
      },
      (err) => {
        setLoadSearchForm(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const onSubmitTeamForm = async (e) => {
    e.preventDefault();

    let validated = validations.validate(
      eventContext.event.team_form.fields,
      errors,
      setErrors,
      eventContext.event,
    );
    if (!validated) return;

    setSubmitFormLoading(true);

    let users = eventContext.users;
    if (users.length === 0) {
      return error('لطفا حداقل یک عضو به تیم اضافه نمایید');
    }

    let usersId = users.map((u) => u.nat_code);
    let data = getFormDataValue(true);
    data['users_id'] = usersId;
    data['event_id'] = id;
    data['users'] = users.map((u) => {
      let fields = {
        user_id: u?.nat_code,
      };
      eventContext.event?.form?.fields?.forEach((f) => {
        fields[f?.name] = u?.[f?.name];
      });
      return fields;
    });

    // if (
    // 	typeof data['supervisor_img'] != 'string' &&
    // 	data['supervisor_img'] !== undefined &&
    // 	data['supervisor_img'] != null
    // ) {
    // 	await useApi.post(
    // 		'/team/upload-image',
    // 		{ photo: data['supervisor_img'] },
    // 		(res) => {
    // 			data['supervisor_img'] = res.data.data.url;
    // 		},
    // 		(err) => {
    // 			setSubmitFormLoading(false);
    // 			error('هنگام ثبت اطلاعات خطایی رخ داده است');
    // 		},
    // 		true,
    // 	);
    // }
    data['team_id'] = state?.teamId;
    await useApi.post(
      `/team/event/${id}/my-team/update`,
      data,
      (res) => {
        let data = res.data.data;
        if (data?.issue_tracking != undefined && data?.success == false) {
          setModalRoleIsOpen(false);
          setSubmitFormLoading(false);
          setOpenErrorModal(true);
          setRetryPayMessage(
            'شما هزینه رویداد را پرداخت نکرده اید لطفا به منوی پرداخت از طریق کد پیگیری مراجعه نموده و از طریق کد پیگیری زیر نسبت به پرداخت حق عضویت خود اقدام نمایید. ',
          );
          setIssueTracking(data?.issue_tracking);
          return error('لطفا حق عضویت خود را پرداخت نمایید');
        }
        // let event = data?.events?.find((e) => e.id == id);
        if (eventContext.event.free === 0) {
          return redirectToPaymentGateway(null, true, data?.issue_tracking);
        }
        success('اطلاعات شما با موفقیت ثبت شد');
        setTeamId(
          encodeURIComponent(data?.issue_tracking?.replaceAll('/', '_')),
        );
        setIssueTracking(data?.issue_tracking);
        setModalRoleIsOpen(false);
        setModalIsOpen(true);
        eventContext.users = [];
        setSubmitFormLoading(false);
        // return navigate('/', { replace: true });
      },
      (err) => {
        if (err?.status === 422) {
          if (err?.data?.error !== undefined) {
            setIssueTracking(error?.data?.issue_tracking);
            setModalRoleIsOpen(false);
            setModalIsOpen(false);
            setModalIssueTracking(true);
            error(`شما قبلا در ${eventContext.event.title} ثبت نام کرده اید`);
          }
        } else {
          error('اطلاعات به علت خطا ثبت نشد');
        }

        setSubmitFormLoading(false);
      },
    );
  };

  const onSubmitEventTypeTeamForm = async (e) => {
    e.preventDefault();

    let validated = validations.validate(
      eventContext.event.team_form.fields,
      errors,
      setErrors,
      eventContext.event,
    );
    if (!validated) return;

    setSubmitFormLoading(true);

    let users = eventContext.users;
    if (users.length === 0) {
      return error('لطفا حداقل یک عضو به تیم اضافه نمایید');
    }
    let values = {};
    let data = getFormDataValue(true);
    await useApi.post(
      '/user',
      data,
      (res) => {
        values['supervisor_id'] = data.nat_code;
      },
      (err) => {
        error('خطا در ثبت اطلاعات');
      },
    );
    let usersId = users.map((u) => u.nat_code);
    values['users_id'] = usersId;
    data['users'] = users.map((u) => {
      let fields = {
        user_id: u?.nat_code,
      };
      eventContext.event?.form?.fields?.forEach((f) => {
        fields[f?.name] = u?.[f?.name];
      });
      return fields;
    });
    values['users'] = data['users'];
    values['event_id'] = id;
    values['province_id'] = data.province_id;
    values['city'] = data.city;
    values['create_date_event'] = data?.create_date_event;
    // if (createDate.length > 0) {
    //   values['create_date_event'] = createDate;
    // }
    values['team_id'] = state?.teamId;
    await useApi.post(
      `/team/event/${id}/my-team/update`,
      values,
      (res) => {
        let data = res.data.data;
        if (data?.issue_tracking != undefined && data?.success == false) {
          setModalRoleIsOpen(false);
          setSubmitFormLoading(false);
          setOpenErrorModal(true);
          setRetryPayMessage(
            'شما هزینه رویداد را پرداخت نکرده اید لطفا به منوی پرداخت از طریق کد پیگیری مراجعه نموده و از طریق کد پیگیری زیر نسبت به پرداخت حق عضویت خود اقدام نمایید. ',
          );
          setIssueTracking(data?.issue_tracking);
          return error('لطفا حق عضویت خود را پرداخت نمایید');
        }
        let event = data?.event;
        if (eventContext.event.free === 0) {
          return redirectToPaymentGateway(
            null,
            data.issue_tracking,
            data?.issue_tracking,
          );
        }
        success('اطلاعات شما با موفقیت ثبت شد');
        setTeamId(
          encodeURIComponent(data?.issue_tracking?.replaceAll('/', '_')),
        );
        setIssueTracking(data?.issue_tracking);
        setModalRoleIsOpen(false);
        setModalIsOpen(true);
        eventContext.users = [];
        setSubmitFormLoading(false);
        // return navigate('/', { replace: true });
      },
      (err) => {
        if (err?.status === 422) {
          if (err?.data?.error !== undefined) {
            error(`شما قبلا در ${eventContext.event.title} ثبت نام کرده اید`);
          }
        } else {
          error('اطلاعات به علت خطا ثبت نشد');
        }

        setSubmitFormLoading(false);
      },
    );
  };

  const nullValueTeamField = () => {
    let fields = [...eventContext.event?.team_form?.fields];
    fields.forEach((field) => {
      let findIndex = fields.findIndex((f) => f.id === field.id);
      if (findIndex !== -1) {
        fields[findIndex].value = '';
      }
    });

    eventContext.event.team_form.fields = fields;
  };

  const setTeamExistsData = (team) => {
    let fields = [...eventContext.event?.team_form?.fields];

    Object.entries(team).forEach((el, index) => {
      let findFieldIndex = fields.findIndex((f) => f.name === el[0]);

      if (findFieldIndex !== -1) {
        if (fields[findFieldIndex].type === 'date') {
          fields[findFieldIndex].value =
            el[1] == null ? null : toJalaliPickerValue(el[1]);
        } else if (fields[findFieldIndex].name === 'nat_code') {
          if (el[1].substr(0, 4) === 'FGN-') {
            fields[findFieldIndex]['isForeigners'] = true;
            fields[findFieldIndex].value = el[1].substr(4);
          }
        } else {
          fields[findFieldIndex].value = el[1];
        }
      }
    });
    eventContext.users = team.users;
    eventContext.event.team_form.fields = fields;
    setModalAddTeam(false);
    setShowTeamForm(true);
  };
  const searchEventTypeTeam = async () => {
    eventContext.users = [];
    if (!isValidIranianNationalCode(natSupervisorCode)) {
      error('لطفا کد ملی را به درستی وارد کنید');
      return;
    }
    if (provinceId.length === 0) {
      error('لطفا استان را انتخاب کنید');
      return;
    }
    if (city.length === 0) {
      error('لطفا شهرستان را وارد کنید');
      return;
    }
    if (createDate.length === 0) {
      error('لطفا تاریخ برگذاری رویداد وارد کنید');
      return;
    }

    if (
      moment(createDate, 'jYYYY/jMM/jDD').isBefore(
        moment(eventContext.event.start_register_date, 'YYYY-MM-DD HH:mm:ss'),
      )
    ) {
      error(
        `تاریخ برگزاری رویداد نمیتواند کوچک تر از ${moment(
          eventContext.event.start_register_date,
          'YYYY-MM-DD HH:mm:ss',
        )
          .locale('fa')
          .format('YYYY/MM/DD')} باشد`,
      );
      return;
    }
    if (
      moment(createDate, 'jYYYY/jMM/jDD').isAfter(
        moment(eventContext.event.end_register_date, 'YYYY-MM-DD HH:mm:ss'),
      )
    ) {
      error(
        `تاریخ برگزاری رویداد نمیتواند بزرگتر از ${moment(
          eventContext.event.end_register_date,
          'YYYY-MM-DD HH:mm:ss',
        )
          .locale('fa')
          .format('YYYY/MM/DD')} باشد`,
      );
      return;
    }
    let createEventDate = jalaliDateToGregorianApi(createDate);

    setLoadSearchForm(true);
    await useApi.get(
      `/team/search/event/${id}/${natSupervisorCode}/${provinceId}/${city}/${createEventDate}`,
      {},
      (res) => {
        let data = res.data.data;
        setSupervisorExistsData(data.supervisor);
        setSupervisorExistsData(data);
        if (data.users != null) {
          eventContext.users = data.users;
        }

        setShowTeamForm(true);
        setLoadSearchForm(false);
      },
      (err) => {
        setLoadSearchForm(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const setSupervisorExistsData = (supervisor) => {
    let fields = [...eventContext.event?.team_form?.fields];

    if (supervisor !== undefined && supervisor != null) {
      Object.entries(supervisor).forEach((el, index) => {
        let findFieldIndex = fields.findIndex((f) => f.name === el[0]);

        if (findFieldIndex !== -1) {
          if (fields[findFieldIndex].type === 'date') {
            fields[findFieldIndex].value =
              el[1] == null ? null : toJalaliPickerValue(el[1]);
          } else if (fields[findFieldIndex].name === 'nat_code') {
            if (el[1].substr(0, 4) === 'FGN-') {
              fields[findFieldIndex]['isForeigners'] = true;
              fields[findFieldIndex].value = el[1].substr(4);
            }
          } else {
            fields[findFieldIndex].value = el[1];
          }
        }
      });
      eventContext.event.team_form.fields = fields;
    }

    setModalAddTeam(false);
    setShowTeamForm(true);
  };

  const changeForeigners = async (id, val, teamForm = false) => {
    setLoadSwitch(true);
    let fields = undefined;
    if (teamForm) {
      fields = [...eventContext.event?.team_form?.fields];
    } else {
      fields = [...eventContext.event?.form?.fields];
    }

    let currentFieldIndex = fields.findIndex((f) => f.id === id);
    if (currentFieldIndex !== -1) {
      fields[currentFieldIndex]['isForeigners'] = val;
    }
    if (teamForm) {
      eventContext.event.team_form.fields = await fields;
    } else {
      eventContext.event.form.fields = await fields;
    }
    setLoadSwitch(false);
  };

  const removeUserInTeam = async (natCode) => {
    setRemoveLoading(true);
    const usersCpy = [...eventContext.users];
    let usersFiltred = usersCpy.filter((u) => u.nat_code !== natCode);

    eventContext.users = await usersFiltred;
    success('کاربر مورد نظر با موفقیت از لیست شما حذف شد');
    setRemoveLoading(false);
  };

  const changeFandomField = (name, value) => {
    setFandomField((prevState) => ({ ...prevState, [name]: value }));
  };

  const [cityLoading, setCityLoading] = useState(false);
  const getCities = async (provinceId) => {
    setCityLoading(true);
    await useApi.get(
      `/city/${provinceId}`,
      {},
      (res) => {
        eventContext.cities = res.data.data;
        setCityLoading(false);
      },
      (err) => {
        error('خطا هنگام جستجو شهرها');
        setCityLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master
      showSidebar={false}
      containerFullWidth={true}
      headerFixed={
        !modalIsOpen && !modalRoleIsOpen && !modalAddTeam ? true : false
      }
      title={`ثبت نام | ${eventContext.event?.title}`}
    >
      <div className='w-100 bg-dark-mode-3 d-flex flex-column vh-100'>
        {eventContext.event.type === 2 ? (
          <Team
            setClubName={setClubName}
            searchTeam={searchTeam}
            errors={errors}
            eventContext={eventContext}
            formGenerate={formGenerate}
            loadSearchForm={loadSearchForm}
            modalAddTeam={modalAddTeam}
            setModalAddTeam={setModalAddTeam}
            showTeamForm={showTeamForm}
            searchUser={searchUser}
            setNatCode={setNatCode}
            setMobile={setMobile}
            searchLoading={searchLoading}
            submitFormLoading={submitFormLoading}
            registerInEvent={registerInEvent}
            setModalRoleIsOpen={setModalRoleIsOpen}
            modalRoleIsOpen={modalRoleIsOpen}
            setErrors={setErrors}
            onSubmitTeamForm={onSubmitTeamForm}
            showUserRegisterForm={showUserRegisterForm}
            setShowUserRegisterForm={setShowUserRegisterForm}
            setShowTeamForm={setShowTeamForm}
            setTeamExistsData={setTeamExistsData}
            setClubPhone={setClubPhone}
            foreigners={foreigners}
            loadSwitch={loadSwitch}
            changeForeigners={changeForeigners}
            setForeigners={setForeigners}
            removeUserInTeam={removeUserInTeam}
            removeLoading={removeLoading}
            fandomField={fandomField}
            changeFandomField={changeFandomField}
            getCities={getCities}
            cityLoading={cityLoading}
          />
        ) : null}

        {eventContext.event.type === 3 ? (
          <EventType
            searchEventTypeTeam={searchEventTypeTeam}
            errors={errors}
            eventContext={eventContext}
            formGenerate={formGenerate}
            loadSearchForm={loadSearchForm}
            modalAddTeam={modalAddTeam}
            setModalAddTeam={setModalAddTeam}
            showTeamForm={showTeamForm}
            searchUser={searchUser}
            setNatCode={setNatCode}
            setMobile={setMobile}
            searchLoading={searchLoading}
            submitFormLoading={submitFormLoading}
            registerInEvent={registerInEvent}
            setModalRoleIsOpen={setModalRoleIsOpen}
            modalRoleIsOpen={modalRoleIsOpen}
            setErrors={setErrors}
            onSubmitEventTypeTeamForm={onSubmitEventTypeTeamForm}
            showUserRegisterForm={showUserRegisterForm}
            setShowUserRegisterForm={setShowUserRegisterForm}
            setShowTeamForm={setShowTeamForm}
            setTeamExistsData={setTeamExistsData}
            setProvinceId={setProvinceId}
            setCreateDate={setCreateDate}
            createDate={createDate}
            setCity={setCity}
            foreigners={foreigners}
            loadSwitch={loadSwitch}
            changeForeigners={changeForeigners}
            setForeigners={setForeigners}
            setNatSupervisorCode={setNatSupervisorCode}
            removeUserInTeam={removeUserInTeam}
            removeLoading={removeLoading}
          />
        ) : null}
      </div>

      <ModalCustom modalIsOpen={modalRoleIsOpen}>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row border-bottom pb-2'>
            <i className='fad fa-warning f-20 mx-2'></i>
            <span className=''>قوانین ثبت اطلاعات</span>
          </div>

          <div className='d-flex flex-column justify-content-center align-content-center'>
            {eventContext.event.roles?.map((item, index) => (
              <a
                target='_blank'
                className='text-dark-mode f-14 mx-auto font-weight-bold text-hover d-flex mt-2'
                href={item}
              >
                دریافت قوانین و دستور العمل ({index + 1})
              </a>
            ))}
          </div>
          <div className='d-flex flex-row justify-content-center my-3'>
            <button
              onClick={() => setModalRoleIsOpen(false)}
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13'
            >
              لغو
            </button>
            <div className='d-flex flex-row justify-content-end mx-3'>
              {submitFormLoading ? (
                <div
                  className='spinner-border spinner-border-sm text-white mb-1'
                  role='status'
                ></div>
              ) : (
                <>
                  {eventContext.event.type == 1 ? (
                    <button
                      onClick={() => {
                        let submitBnt = document.getElementById('submit-btn');
                        submitBnt.click();
                      }}
                      className='btn  btn bg-purple shadow-sm border text-dark-mode text-hover f-13 p-2 f-13'
                    >
                      قبول قوانین و ثبت نام
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        let submitBnt =
                          document.getElementById('submit-team-form');
                        submitBnt.click();
                      }}
                      className='btn  btn bg-purple shadow-sm border text-dark-mode text-hover f-13 p-2 f-13'
                    >
                      قبول قوانین و ثبت نام
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </ModalCustom>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row border-bottom pb-2'>
            <i className='fad fa-warning f-20 mx-2'></i>
            <span className=''>اطلاعات پیگیری</span>
          </div>
          <span className='text-dark-mode font-weight-bold text-center my-3'>
            اطلاعات با موفقیت ثبت شد
          </span>
          <span className='text-dark-mode font-weight-bold text-center my-3'>
            جهت اتمام مراحل ثبت نام کد رهگیری را به مربی خود ارائه دهید.
          </span>
          <div className='d-flex flex-row justify-content-center'>
            <span className='text-dark-mode f-15 font-weight-bold mx-2'>
              شماره پیگیری :
            </span>
            <span className='text-dark-mode f-15 font-weight-bold'>
              {issueTracking}
            </span>
          </div>
          <div className='d-flex flex-row justify-content-center my-3'>
            {eventContext.event.type == 1 ? (
              <a
                href={registerPrintUrl(id, issueTracking, 'user')}
                target='_blank'
                rel='noreferrer'
                className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13 mx-2'
              >
                پرینت نتیجه ثبت نام
              </a>
            ) : (
              <a
                href={registerPrintUrl(id, issueTracking, 'team')}
                target='_blank'
                rel='noreferrer'
                className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13 mx-2'
              >
                پرینت نتیجه ثبت نام
              </a>
            )}

            <Link
              to='/'
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13'
            >
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </ModalCustom>
      <ModalCustom modalIsOpen={openErrorModal}>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row border-bottom pb-2'>
            <i className='fad fa-warning f-20 mx-2'></i>
            <span className=''>اطلاعات پیگیری</span>
          </div>
          {retryPayMessage.length > 0 ? (
            <span className='text-warning font-weight-bold text-center f-13 my-2'>
              {retryPayMessage}
            </span>
          ) : (
            <>
              <span className='text-warning font-weight-bold text-center my-2'>
                خطای اتصال به درگاه پرداخت
              </span>
              <span className='text-warning font-weight-bold text-center f-13 my-2'>
                هنگام اتصال به درگاه پرداخت خطایی رخ داده است لطفا کد پیگیری خود
                را یادداشت نموده و از طریق منوی پرداخت از طریق کد پیگیری مجددا
                اقدام به .پرداخت نمایید
              </span>
              <span className='text-warning font-weight-bold text-center f-14  my-1'>
                نکته : در صورت عدم یادداشت کد پیگیری ثبت نام مجدد در رویداد
                امکان پذیر نمی باشد.
              </span>
            </>
          )}

          <div className='d-flex flex-row justify-content-center'>
            <span className='text-dark-mode f-15 font-weight-bold mx-3'>
              شماره پیگیری :
            </span>
            <span className='text-dark-mode f-15 font-weight-bold'>
              {issueTracking}
            </span>
          </div>
          <div className='d-flex flex-row justify-content-center my-3'>
            <Link
              to='/'
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13'
            >
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </ModalCustom>

      <ModalCustom modalIsOpen={modalIssueTracking}>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row border-bottom pb-2'>
            <i className='fad fa-warning f-20 mx-2'></i>
            <span className=''>اطلاعات پیگیری</span>
          </div>

          <span className='text-warning font-weight-bold text-center my-2'>
            اگر درگاه در درگاه پرداخت به مشکل خورده اید لطفا کد پیگیری را
            یادداشت نموده و از طریق منو های بالا به بخش پرداخت از طریق کد پیگیری
            مراجعه نمایید.
          </span>

          <div className='d-flex flex-row justify-content-center'>
            <span className='text-dark-mode f-15 font-weight-bold mx-3'>
              شماره پیگیری :
            </span>
            <span className='text-dark-mode f-15 font-weight-bold'>
              {issueTracking}
            </span>
          </div>
          <div className='d-flex flex-row justify-content-center my-3'>
            <Link
              to='/'
              className='btn bg-purple shadow-sm border text-dark-mode text-hover f-13'
            >
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default EditRegister;
